import { render, staticRenderFns } from "./NeedValidatePhysicianCompanies.vue?vue&type=template&id=1fb4899d&"
import script from "./NeedValidatePhysicianCompanies.vue?vue&type=script&lang=js&"
export * from "./NeedValidatePhysicianCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports